import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { IShareholderSummaryInfo } from '@appShared/interfaces/[Model-based]/shareholder-summary-info.interface';
import {
  ShareholderApiActions,
  ShareholderPageActions
} from '../actions/shareholder';

export interface ShareholderState {
  shareholders: IShareholderSummaryInfo[];
  searchFilter: string;
  error: string;
}

const intialShareholderState: ShareholderState = {
  shareholders: null,
  searchFilter: '',
  error: ''
};

export const getShareholderFeatureState = createFeatureSelector<
  ShareholderState
>('shareholder');

export const employeeReducer = createReducer<ShareholderState>(
  intialShareholderState,
  on(
    ShareholderApiActions.loadShareholdersSuccess,
    (state, action): ShareholderState => {
      return {
        ...state,
        shareholders: action.shareholders,
        error: ''
      };
    }
  ),
  on(
    ShareholderApiActions.loadShareholdersFailure,
    (state, action): ShareholderState => {
      return {
        ...state,
        shareholders: [],
        error: action.error
      };
    }
  ),
  on(
    ShareholderPageActions.setShareholderSearchFilter,
    (state, action): ShareholderState => {
      return {
        ...state,
        searchFilter: action.searchFilter
      };
    }
  )
);
